<template>
  <div class="container">
    <HeadingOne class="-margin-md">審査結果のご確認</HeadingOne>

    <p>
      このたびは、au PAY
      スマートローンにお申し込みいただき、誠にありがとうございます。<br />
      審査が完了いたしましたので、以下より結果をご確認ください。
    </p>

    <BtngroupSingle class="-margin-lg">
      <BtnMain router-name="en010" class="-main"> 審査結果のご確認へ </BtnMain>
    </BtngroupSingle>
  </div>
  <!-- container -->
</template>

<script>
import { setMeta } from "@/utils/Meta";
import HeadingOne from "@/components/heading/HeadingOne";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
export default {
  name: "En021",
  components: {
    BtnMain,
    BtngroupSingle,
    HeadingOne,
  },
  setup() {
    setMeta({
      title: "審査結果のご確認",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,入会,審査,審査結果",
    });
  },
};
</script>

<style scoped></style>
